<template lang="pug">
b-modal#event-detail(title='Event Summary', :hide-footer='true', @shown='onShown()', @hide='onHide()')
  //.top-background
  .page.container.col-12
    .tabs.d-flex.justify-content-center
      .tab(:class='{active: page === "detail"}', @click='page = "detail"') Detail
      .tab(:class='{active: page === "activity"}', @click='page = "activity"') Activity
    div(v-if='page === "detail"')
      .row
        h2.col-12.text-center.header.d-flex.align-items-center.justify-content-between
          div(v-if='eventData && eventData.eventOptions && favoriteMonster')
            sprite-render.sprite.sprite2.user-sprite(:sprite='eventData.eventOptions')
            .name(v-if='eventData && !eventData.eventOptions.spriteTokenId') {{ spriteName }}
            .name(v-else-if='eventData && eventData.eventOptions.spriteTokenId && !spriteName') Sprite {{`#${eventData.eventOptions.spriteTokenId}`}}
            .name(v-else) {{ spriteName }}
            .progress-bar
              .progress-fill(:style='{width: spriteHealthPercent(eventData) + "%"}')
            .exp-text {{ spriteHealth(eventData) }} / 50 HP
          span vs
          div(v-if='eventData && eventData.eventOptions')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss1"',
              src='../../assets/enemies/1_uguu.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss2"',
              src='../../assets/enemies/2_dandeepu.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss3"',
              src='../../assets/enemies/3_marimissimo.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss4"',
              src='../../assets/enemies/4_pyrite_crab.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss5"',
              src='../../assets/enemies/5_soop.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss6"',
              src='../../assets/enemies/6_nipish.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss7"',
              src='../../assets/enemies/7_bunbun.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss8"',
              src='../../assets/enemies/8_drogon.png')
            img.sprite.sprite2(
              v-if='eventData.eventOptions.boss === "boss9"',
              src='../../assets/enemies/9_fenix.png')
            .name(v-if='eventData.eventOptions.boss') {{ bossById[eventData.eventOptions.boss] }}
            div(v-if='eventData.eventOptions')
              .progress-bar
                .progress-fill(:style='{width: bossHealthPercent(eventData) + "%"}')
              .exp-text {{ bossHealth(eventData) }} / {{ bossHp(eventData) }} HP
      .row.details-row
        .col-12.col-md-4
          div
            h5 Integration
            .pill
              strong(v-if='eventData.eventOptions') {{ eventData.eventOptions.integration | toTitleCase }}
        .col-12.col-md-4(v-if='eventData.eventOptions')
          div
            h5 Difficulty
            .pill
              strong {{ (eventData.eventOptions.difficulty || "Normal") | toTitleCase}}
        .col-12.col-md-4
          div
            h5 Event Time
            .pill
              strong {{ timeAgo }}
      .row
        .col-12
          div(v-if='eventData.eventOptions')
            h5 Tracking
            .card-item(style='margin-left: 1em; margin-right: 1em;').text-align
              | {{ tracking }}
      .row.button-row(v-if='!eventData.completed && eventData.eventOptions && eventData.eventOptions.status !== "defeat"')
        .col-12.text-center
          div.btn.btn-red(@click='abandon()') Abandon
    div(v-if='page === "activity"')
      .row
        .col-12
          activity-list(:activity='eventData.activity')
</template>

<style lang="scss">
  #event-detail {
    .modal-content {
      border-radius: 16px;
      border: none;
    }

    .top-background {
      z-index: 0;
      top: -1px;
      left: 0;
      height: 150px;
      position: absolute;
      width: 100%;
      // height: 736px;
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
      background-image:
        image-set(
          url('../../assets/forest-background.png') 1x,
          url('../../assets/forest-background@2x.png') 2x,
          url('../../assets/forest-background@3x.png') 3x,
        );
    }

    .modal-dialog {
      // width: 588px;
      border-radius: 16px;
      background-color: #ffffff;

      .modal-header {
        border-radius: 16px 16px 0 0;
        background-image: linear-gradient(to right, #9bc75a, #3ba5a8);

        h5.modal-title {
          margin-left: 12em;
          text-align: center;
          text-transform: uppercase;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: 1px;
          text-align: center;
          color: #ffffff;
          // margin: 0 auto;
        }
      }

      button {
        color: #fff;
        opacity: 1;
        text-shadow: none;
      }

      .user-sprite {
        margin-bottom: 2.4rem;

        img {
          margin-top: 1rem;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .tabs {
    margin-bottom: 2rem;

    .tab {
      padding: .5em 1.5em;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 1px;
      text-align: center;
      color: #363734;
      text-transform: uppercase;
    }

    .tab:hover {
      cursor: pointer;
    }

    .tab.active {
      font-weight: bold;
    }

    .tab::after {
      content: '';
      height: 4px;
      display: block;
    }

    .tab.active::after, .tab:hover::after {
      width: 100%;
      border-radius: 999px;
      background-image: linear-gradient(to right, #9bc75a, #3ba5a8);
      border-radius: 8px;
    }
  }

  .page {
    // padding-top: 2em;
    text-align: left;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    margin: 0 10px;
  }

  .boss {
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .boss img {
    width: 250px;
  }

  .header {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  h5 {
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #a1a39e;
    text-transform: uppercase;
  }

  .pill {
    border-radius: 999px;
    background-color: #f7f8f6;
    padding: .5rem 1rem;
    font-size: 14px;
  }

  .details-row {
    text-align: center;
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .header span {
    margin-right: .5em;
  }

  .header img {
    max-width: 100px;
  }

  .circle {
    width: 150px;
    height: 150px;
    background: #fff;
    border-radius: 50%;
    margin: 0 auto;
    margin-bottom: .5em;
  }

  .card-item {
    padding: 1em;
    margin-bottom: 1em;
    border: none;
    background: #f7f8f6;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #6c6d69;
  }

  .button-row {
    margin-bottom: 2em;
  }

  .sprite {
    margin: 0 auto;
    display: block;
    margin-bottom: .8em;
    min-height: 71px;
  }

  .progress-bar {
    margin-bottom: .5em;
    width: 78px;
    height: 4px;
    border-radius: 999px;
    background-color: #d7dad2;
    margin: 0 auto;
  }

  .progress-fill {
    background-color: #e14455;
    width: 20%;
    height: 4px;
    border-radius: 999px;
  }

  .exp-text, .name {
    width: 80px;
    margin: 0 auto;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: 0.5px;
    color: #6c6d69;
    margin-top: .5rem;
    text-align: center;
  }

  .name {
    margin-bottom: .7rem;
  }
</style>

<script>
import axios from 'axios';
import moment from 'moment';

import SpriteRender from '../monsters/SpriteRender';
import ActivityList from '../activity/ActivityList';
import { bossById } from '../../lib/boss';

// @TODO: Share
// @TODO: Fix typos
const eventTrackingOptions = {
  github: {
    pushEvent: {
      label: 'Push Commits',
      value: true,
    },
    comments: {
      label: 'Comments',
      value: true,
    },
    closeIssue: {
      label: 'Close Issue',
      value: true,
    },
    openIssue: {
      label: 'Open Issue',
      value: true,
    },
    completeMilestone: {
      label: 'Complete Milestone',
      value: true,
    },
    subscribeToRepo: {
      label: 'Subscribe to Repo',
      value: true,
    },
    submitPullRequest: {
      label: 'Submit Pull Request',
      value: true,
    },
  },
  habitica: {
    habitis: {
      label: 'Habits',
      value: true,
    },
    dailies: {
      label: 'Dailies',
      value: true,
    },
    todos: {
      label: 'To-dos',
      value: true,
    },
    checklist: {
      label: 'Checklist items',
      value: true,
    },
    // levelup: {
    //   label: 'Level up',
    //   value: true,
    // },
    startQuest: {
      label: 'Start a Quest',
      value: true,
    },
    // completeQuest: {
    //   label: 'Complete a Quest',
    //   value: true,
    // },
    creatTask: {
      label: 'Creating a task',
      value: true,
    },
    // hatchPet: {
    //   label: 'Hatching a pet',
    //   value: true,
    // },
    // raisingMount: {
    //   label: 'Raising a mount',
    //   value: true,
    // },
  },
};

export default {
  name: 'EventDetail',
  components: {
    SpriteRender,
    ActivityList,
  },
  data() {
    return {
      name: '',
      bossById,
      integrations: [
        {
          name: 'Github',
          id: 1,
        },
      ],
      page: 'detail',
      invite: '',
      invites: [],
      selectedIntegrations: [],
      eventData: {},
    };
  },
  mounted() {
    this.$root.$on('show-event-detail', this.showEventDetail);
  },
  destroyed() {
    this.$root.$off('show-event-detail', this.showEventDetail);
  },
  filters: {
    // @TODO: Share
    toTitleCase(str) {
      if (!str) return str;
      return str.replace(
        /\w\S*/g,
        (txt) => {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        },
      );
    },
  },
  computed: {
    spriteName() {
      const spriteName = this.eventData.eventOptions.sprite && this.eventData.eventOptions.sprite.name;
      return spriteName || this.eventData.eventOptions.spriteName;
    },
    tracking() {
      const options = eventTrackingOptions[this.eventData.eventOptions.integration];

      const intOptions = this.eventData.eventOptions.integratonOptions;
      const filteredOptions = Object.keys(intOptions)
        .filter((intOption) => {
          return intOptions[intOption];
        });

      const filteredLabels = filteredOptions
        .map((intOption) => {
          return options[intOption].label;
        });

      return filteredLabels.join(', ');
    },
    eventId() {
      return this.$store.state.eventId;
    },
    timeAgo() {
      return moment(this.eventData.createdAt).fromNow();
    },
    eventItem() {
      const { eventId } = this.$route.params;
      const eventItem = this.$store.state.events.find(e => e.id === eventId);
      return eventItem || {};
    },
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
  },
  methods: {
    onShown() {
      window.amplitude.getInstance().logEvent('VIEW_EVENT_DETAIL');
    },
    async showEventDetail(eventId, page = 'detail') {
      this.page = page;
      const event = await this.$store.dispatch('getEvent', { eventId });
      this.eventData = event;
      this.$root.$emit('bv::show::modal', 'event-detail');
    },
    onHide() {
      this.page = 'detail';

      const defeated = this.eventData.eventOptions.status === 'defeat';
      if (this.eventData.completed || defeated) {
        // @TODO: Move to action
        this.$delete(this.$store.state.viewedActivityDates, this.eventData._id);

        // @TODO: Build a clean up script
        this.$delete(this.$store.state.viewedActivityDates, undefined);
        localStorage.setItem('spritely-viewedActivityDates', JSON.stringify(this.$store.state.viewedActivityDates));
        return;
      }

      this.$store.commit('setLastViewActivityForId', { id: this.eventData._id });
    },
    // @TODO: Move to computed. Share with event box
    spriteHealth(event) {
      return event && event.eventOptions && event.eventOptions.spriteHealth ? event.eventOptions.spriteHealth : 50;
    },
    spriteHealthPercent(event) {
      return (this.spriteHealth(event) / 50) * 100;
    },
    bossHp(event) {
      if (event.eventOptions.difficulty === 'hard') return 200;
      if (event.eventOptions.difficulty === 'nightmare') return 300;
      return 100;
    },
    bossHealth(event) {
      return event && event.eventOptions && event.eventOptions.bossHealth >= 0 ? event.eventOptions.bossHealth : this.bossHp(event);
    },
    bossHealthPercent(event) {
      return (this.bossHealth(event) / this.bossHp(event)) * 100;
    },
    abandon() {
      if (!confirm('Are you sure you want to remove this event? You can not undo this.')) return;

      axios.delete(`/events/${this.eventData._id}`);

      // @TODO: Move to action
      this.$store.state.events = this.$store.state.events.filter(e => e._id !== this.eventData._id);
      this.$root.$emit('bv::hide::modal', 'event-detail');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/events/EventDetail.vue